<template>
    <div class="page-container">
        <el-tabs v-model="activeName" @tab-click="topTabChange">
            <el-tab-pane name="audit" label="提现审批">
                <el-card class="page-content" shadow="never">
                    <el-tabs :value="activeTab" @tab-click="handleTabChange">
                        <el-tab-pane label="已提交" name="1"></el-tab-pane>
                        <el-tab-pane label="已审核" name="4"></el-tab-pane>
                        <el-tab-pane label="区块链网络已经发送，等待确认中" name="5"></el-tab-pane>
                        <el-tab-pane label="提现成功" name="0"></el-tab-pane>
                        <el-tab-pane label="失败" name="-1"></el-tab-pane>
                        <el-tab-pane label="已取消" name="2"></el-tab-pane>
                        <el-tab-pane label="系统异常" name="6"></el-tab-pane>
                        <el-tab-pane label="管理员撤销" name="7"></el-tab-pane>
                    </el-tabs>
                    <div class="page-actions">
                        <el-autocomplete
                                class="inline-input"
                                v-model="selectedCoin"
                                :fetch-suggestions="querySearch"
                                placeholder="请输入币种"
                                @select="handleSelect"
                                @keyup.native.enter="handleSearch">
                            <i
                                    class="el-icon-close el-input__icon"
                                    slot="suffix"
                                    @click="cleanSearchCoin"
                                    style="cursor:pointer;">
                            </i>
                        </el-autocomplete>
                        <el-input placeholder="请输入账号ID" clearable v-model="userId" @keyup.native.enter="handleSearch">>
                            <i slot="prefix" class="el-input__icon el-icon-search"></i>
                        </el-input>
                        <el-input placeholder="请输入提现地址" clearable v-model="walletAddres"
                                  @keyup.native.enter="handleSearch">
                            <i slot="prefix" class="el-input__icon el-icon-search"></i>
                        </el-input>
                        <el-select v-if="typeStatu" v-model="approvalType" clearable placeholder="请选择过审类型">
                                <el-option key="0" label="人工" value="0"/>
                                <el-option key="1" label="系统小额过审" value="1"/>
                            </el-select>
                        <el-input placeholder="请输入提现memo" clearable v-model="memo"
                                  @keyup.native.enter="handleSearch">
                            <i slot="prefix" class="el-input__icon el-icon-search"></i>
                        </el-input>
                        <el-date-picker v-model="dataArry" value-format="timestamp" type="datetimerange" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间">
                        </el-date-picker>
                        <el-input placeholder="充值最小值" v-model="minNum" style="width: 200px"></el-input>
                        <el-input placeholder="充值最大值" v-model="maxNum" style="width: 200px"></el-input>
                        <el-button @click="handleSearch" type="primary">搜索</el-button>
                        <el-checkbox v-model="showTagUser" @change="changeShowTag()" label="展示标签用户"></el-checkbox>
                    </div>
                    <audit-list @refresh="getList"></audit-list>
                </el-card>
            </el-tab-pane>
            <el-tab-pane name="trade" label="查询用户今日交易信息">
                <el-form :inline="true">
                    <el-form-item label="用户ID">
                        <el-input v-model="queryTradeUserId"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="getTradeInfo()">查询交易信息</el-button>
                    </el-form-item>
                </el-form>
                <div>交易方向：买</div>
                <el-table :data="bidInfo">
                    <el-table-column label="买家ID" prop="buyerId"></el-table-column>
                    <el-table-column label="卖家ID" prop="sellerId"></el-table-column>
                    <el-table-column label="交易对" prop="pair"></el-table-column>
                    <el-table-column label="金额" prop="dealAmount"></el-table-column>
                    <el-table-column label="价格" prop="price"></el-table-column>
                    <el-table-column label="买家下单来源" prop="buyerSrc"></el-table-column>
                    <el-table-column label="卖家下单来源" prop="sellerSrc"></el-table-column>
                    <el-table-column label="买家手续费币种" prop="buyerFeeCoinType"></el-table-column>
                    <el-table-column label="卖家手续费币种" prop="sellerFeeCoinType"></el-table-column>
                    <el-table-column label="买家手续费" prop="buyerFee"></el-table-column>
                    <el-table-column label="卖家手续费" prop="sellerFee"></el-table-column>
                    <el-table-column label="关联的买家订单号" prop="refBuyOrder"></el-table-column>
                    <el-table-column label="关联的卖家订单号" prop="refSellOrder"></el-table-column>
                </el-table>
                <el-pagination background layout="prev, pager, next" :total="totalBuy" :page-size="25"
                               :current-page.sync="pageNoBuy"
                               @current-change="changePageBuy"></el-pagination>
                <div style="margin-top: 20px;">交易方向：卖</div>
                <el-table :data="askInfo">
                    <el-table-column label="买家ID" prop="buyerId"></el-table-column>
                    <el-table-column label="卖家ID" prop="sellerId"></el-table-column>
                    <el-table-column label="交易对" prop="pair"></el-table-column>
                    <el-table-column label="金额" prop="dealAmount"></el-table-column>
                    <el-table-column label="价格" prop="price"></el-table-column>
                    <el-table-column label="买家下单来源" prop="buyerSrc"></el-table-column>
                    <el-table-column label="卖家下单来源" prop="sellerSrc"></el-table-column>
                    <el-table-column label="买家手续费币种" prop="buyerFeeCoinType"></el-table-column>
                    <el-table-column label="卖家手续费币种" prop="sellerFeeCoinType"></el-table-column>
                    <el-table-column label="买家手续费" prop="buyerFee"></el-table-column>
                    <el-table-column label="卖家手续费" prop="sellerFee"></el-table-column>
                    <el-table-column label="关联的买家订单号" prop="refBuyOrder"></el-table-column>
                    <el-table-column label="关联的卖家订单号" prop="refSellOrder"></el-table-column>
                </el-table>
            </el-tab-pane>
            <el-tab-pane name="recheck" label="二次审核额度设置">
                <el-form>
                    <el-form-item>
                        <el-input placeholder="请输入内容" v-model="recheckAmount" class="input-with-select" style="width: 30%;">
                            <el-button slot="prepend" @click="recheckAmount = 0.1">最小</el-button>
                            <el-button slot="append" @click="recheckAmount = 100000">最大</el-button>
                        </el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="success" @click="saveRecheckAmount()">确认修改</el-button>
                    </el-form-item>
                </el-form>
            </el-tab-pane>

            <el-pagination background layout="prev, pager, next" :total="totalSell" :page-size="25"
                           :current-page.sync="pageNoSell"
                           @current-change="changePageSell"/>

        </el-tabs>
    </div>
</template>

<script>
    import './store';
    import AuditList from './components/list';
    import {mapState, mapMutations, mapActions} from 'vuex';
    import api from "./api";

    export default {
        name: 'WithdrawalAudit',
        data() {
            return {
                selectedCoin: '',
                nowCoin: '',
                userId: '',
                walletAddres: '',
                memo:'',
                approvalType:'',
                activeName: 'audit',
                queryTradeUserId: '',
                pageNoBuy: 1,
                pageNoSell: 1,
                showTagUser: false,
                recheckAmount: 5000,
                minNum: '',
                maxNum: '',
                dataArry:[],
                typeStatu:false
            };
        },
        components: {
            AuditList
        },
        computed: {
            ...mapState('withdrawalAudit', [
                'activeTab',
                'chooseCoinType',
                'allCoins',
                'pagination',
                'bidInfo',
                'askInfo',
                'totalSell',
                'totalBuy',
            ])
        },
        methods: {
            handleSelect() {

            },
            cleanSearchCoin() {
                this.selectedCoin = '';
            },
            querySearch(queryString, cb) {
                var results = [];
                var coinList = this.allCoins;
                results = queryString ? coinList.filter(this.createFilter(queryString)) : coinList;
                results = results.map((v, i, arr) => {
                    return {
                        value: v
                    }
                });
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            createFilter(queryString) {
                let tempData = this.allCoins;
                return (tempData) => {
                    return (tempData.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            ...mapMutations('withdrawalAudit', ['changeTab']),
            ...mapActions('withdrawalAudit', [
                'list',
                'listCoinType',
                'listBillType',
                'getAllCoins',
                'changeCoinType',
                'getTradeBuyInfo',
                'getTradeSellInfo',
                'saveShowTag'
            ]),
            handleTabChange(tab) {
                if(tab.name == 1){
                    this.typeStatu = false
                }else{
                    this.typeStatu = true
                }
                this.changeTab(tab.name);
                this.getList({
                    page: 1
                });
            },
            getList(data = {}) {
                this.list({
                    userId: this.userId,
                    txStatus: this.activeTab,
                    walletAddres: this.walletAddres,
                    memo:this.memo,
                    coinType: this.selectedCoin.toUpperCase(),
                    showTag: this.showTagUser,
                    minNum: this.minNum,
                    maxNum: this.maxNum,
                    approvalType:this.approvalType,
                    startTime: this.dataArry!=null?this.dataArry[0]:null,
                    endTime: this.dataArry!=null?this.dataArry[1]:null,
                    ...this.pagination,
                    ...data
                });
            },
            handleSearch() {
                this.getList({
                    page: 1
                });
            },

            getTradeInfo() {
                this.changePageBuy();
                this.changePageSell();
            },

            changePageBuy() {
                let data = {
                    userId: this.queryTradeUserId,
                    page: this.pageNoBuy
                };
                console.log(data)
                this.getTradeBuyInfo(data);
            },

            changePageSell() {
                let data = {
                    userId: this.queryTradeUserId,
                    page: this.pageNoBuy
                }
                this.getTradeSellInfo(data);
            },

            changeShowTag() {
                this.saveShowTag(this.showTagUser);
                this.getList();
            },

            saveRecheckAmount() {
                api.setRecheckAmount({amount: this.recheckAmount}).then(() => this.$message.success('修改成功'));
            },
            topTabChange(tab) {
                if (tab.name === 'recheck') {
                    api.getRecheckAmount().then(response => this.recheckAmount = response.data);
                }
            }
        },
        watch: {
            nowCoin(val) {
                this.changeCoinType(val);
                this.getList({
                    page: 1
                });
            },

        },
        created() {
            this.typeStatu = this.activeTab == 1?false:true;
                console.log(this.activeTab)
            this.getAllCoins();
            this.getList();
        }
    };
</script>

<style lang="less">
    .user-withdrawal-link {
        color: #409eff;

        .cell {
            span {
                &:hover {
                    text-decoration: underline;
                }
            }
        }
    }

    .user-withdrawal-records-wrap {
        .el-table {
            .cell {
                font-size: 12px;
                text-align: center;
            }
        }

        .user-withdrawal-pager-wrap {
            text-align: right;
            margin: 10px 0px;
        }
    }
</style>
